import { editorialRequest } from 'app/config/editorialRequest.config';

export const PROGRAMS = 'lms/courses';

export function getProgram(guid, params = {}) {
  return editorialRequest('read', 'get', `${PROGRAMS}/${guid}`, { params: { ...params, isEditorial: 1 } });
}

export function getPrograms(params) {
  return editorialRequest('read', 'get', PROGRAMS, { params });
}

export function createProgram(params) {
  return editorialRequest('write', 'post', PROGRAMS, params);
}

export function updateProgram(params) {
  return editorialRequest('write', 'put', `${PROGRAMS}/${params.guid}`, params);
}

export function deleteProgram(params = { guid: [] }) {
  return editorialRequest('write', 'delete', PROGRAMS, { data: params });
}

export function cloneProgram(params) {
  return editorialRequest('write', 'post', 'lms/courses-clone', params);
}

// ---------------------------------------------------
//  RELATED
// ---------------------------------------------------

export function getProgramsRelated(courseGuid, params = {}) {
  // ?pageSize=2&offset=0
  return editorialRequest('read', 'get', `${PROGRAMS}/${courseGuid}/related`, { params });
}

// ---------------------------------------------------
//  PROGRAM HOME TEMPLATE CRUD
// ---------------------------------------------------
export function getHomeTemplate(courseGuid) {
  return editorialRequest('read', 'get', `v3/home-templates/${courseGuid}`);
}

export function createHomeTemplate(params) {
  return editorialRequest('write', 'post', 'v3/home-templates', params);
}

export function updateHomeTemplate(templateId, params) {
  return editorialRequest('write', 'put', `v3/home-templates/${templateId}`, params);
}

export function patchHomeTemplate(templateId, params) {
  return editorialRequest('write', 'patch', `v3/home-templates/${templateId}`, params);
}

export function cloneHomeTemplate(courseGuid, params) {
  return editorialRequest('write', 'post', `v3/home-templates/${courseGuid}/clone`, params);
}
